import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
export function Results() {
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: containerRef,
    offset: ['start end', 'end start']
  });
  const results = [{
    letter: 'В',
    title: 'Ви виходите',
    desc: 'З реактивного режиму, де рішення приймаються під тиском, а бізнес тримаєть на вас і постійній тривозі за результат.'
  }, {
    letter: 'М',
    title: 'Ви мислите',
    desc: "Як підприємець і лідер, а не як виконавець у власному бізнесі. З'являється ясність, фокус і розуміння, що робити далі."
  }, {
    letter: 'О',
    title: 'Ви отримуєте',
    desc: 'Систему стабільного залучення клієнтів під ваш бізнес. Формула Growth Acquisition дозволяє бачити точки зростання.'
  }, {
    letter: 'К',
    title: 'Ви керуєте',
    desc: 'Зростанням, а не реагуєте на проблеми. Маркетинг стає під контролем, команда працює в системі.'
  }];
  return <section ref={containerRef} className="relative min-h-[160vh] md:min-h-[200vh] mb-0 pb-0" data-id="element-373">
      {/* Background Image - full width on mobile, 4/5 on desktop */}
      <div className="sticky top-0 h-screen overflow-hidden" data-id="element-374">
        <div className="absolute inset-0 flex justify-center" data-id="element-375">
          <div className="w-full md:w-4/5 h-full relative" data-id="element-376">
            <img src="https://cdn.magicpatterns.com/uploads/ugWXoigWXdAvDGxjsqpgyT/large-panoramic-windows-view-city-night.jpg" alt="" className="w-full h-full object-cover" style={{
            paddingBottom: "100px"
          }} data-id="element-377" />
            <div className="absolute inset-0 bg-gradient-to-b from-[#070728]/50 via-[#070728]/30 to-[#151575]/70" style={{
            marginBottom: "95px"
          }} data-id="element-378" />
          </div>
        </div>

        {/* Fixed Header Content - positioned higher */}
        <div className="relative z-10 pt-3 md:pt-10" data-id="element-379">
          <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-380">
            {/* Tags - positioned higher, blue color, Оборот at the end */}
            <div className="flex flex-wrap justify-center gap-1.5 md:gap-3 mb-2 md:mb-4" data-id="element-381">
              {['Мислення', 'Рішення', 'Система', 'Зростання', 'Лідерство', 'Оборот'].map(tag => <span key={tag} className="px-2 md:px-4 py-0.5 md:py-1.5 rounded-full bg-blue-500/20 text-blue-400 text-[10px] md:text-sm font-medium border border-blue-500/40 backdrop-blur-md" data-id="element-382">
                  {tag}
                </span>)}
            </div>

            {/* Title - single line */}
            <div className="text-center mb-2" data-id="element-383">
              <h2 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white" data-id="element-384">
                За 6 тижнів{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-cyan-300 to-blue-500" data-id="element-385">
                  Ви:
                </span>
              </h2>
            </div>
          </div>
        </div>
      </div>

      {/* Scrolling Cards - adjusted for mobile */}
      <div className="relative z-20 -mt-[65vh] md:-mt-[72vh]" data-id="element-386">
        <div className="max-w-2xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-387">
          <div className="flex flex-col gap-3 md:gap-6" data-id="element-388">
            {results.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 100
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: false,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="relative bg-white rounded-xl md:rounded-2xl p-4 md:p-8 shadow-2xl" data-id="element-389">
                {/* Letter badge - top right */}
                <div className="absolute top-3 md:top-4 right-3 md:right-4 w-7 h-7 md:w-10 md:h-10 bg-gray-900 rounded-lg flex items-center justify-center" data-id="element-390">
                  <span className="text-white font-bold text-sm md:text-lg" data-id="element-391">
                    {item.letter}
                  </span>
                </div>

                <h3 className="text-base sm:text-lg md:text-2xl font-bold text-gray-900 mb-2 md:mb-4 pr-10 md:pr-14" data-id="element-392">
                  {item.title}
                </h3>
                <p className="text-xs md:text-base text-gray-600 leading-relaxed" data-id="element-393">
                  {item.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}